import { groupIds } from './groups';
import { ids } from './ids';

/**
 * Display copy for every topic. `satisfies` makes a missing topic a compile error.
 * All user-facing topic wording lives here so it can be reviewed in one place.
 */
export const details = {
	'chat-mention': {
		group: 'chat',
		label: 'Mentions in chat',
		description: 'When someone @mentions you in a job or design chat.',
	},
	'job-assignment': {
		group: 'assignments',
		label: 'Job stage assigned to me',
		description: 'When a job stage is assigned to you.',
	},
	'transaction-assignment': {
		group: 'assignments',
		label: 'Design stage assigned to me',
		description: 'When a design, review or QA stage is assigned or re-assigned to you.',
	},
	'transaction-unassigned': {
		group: 'assignments',
		label: 'Designs waiting for assignment',
		description: 'When a design is ready and needs someone assigned.',
	},
	'job-created': {
		group: 'job-updates',
		label: 'New jobs',
		description: 'When a new job is submitted.',
	},
	'job-completed': {
		group: 'job-updates',
		label: 'Job completed',
		description: 'When a job is complete and its design files are ready.',
	},
	'transaction-completed': {
		group: 'job-updates',
		label: 'Design completed',
		description: 'When a design is completed and its files are ready.',
	},
	'transaction-reworked': {
		group: 'job-updates',
		label: 'Design sent for rework',
		description: 'When a completed design is sent back for rework.',
	},
	'transaction-unallocated': {
		group: 'job-updates',
		label: 'Designs waiting for allocation',
		description: 'When a design has no client allocated yet.',
	},
	'fpc-job-completed': {
		group: 'plan-comparison',
		label: 'Plan comparison completed',
		description: 'When a floor plan comparison you started has finished.',
	},
	'recipe-copy-completed': {
		group: 'recipe-admin',
		label: 'Recipe copy completed',
		description: 'When a recipe copy you started has finished.',
	},
	'recipe-copy-failed': {
		group: 'recipe-admin',
		label: 'Recipe copy failed',
		description: 'When a recipe copy you started has failed.',
	},
} as const satisfies Record<
	(typeof ids)[number],
	{ group: (typeof groupIds)[number]; label: string; description: string }
>;
